"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/icon/icon");
const tag_styles_1 = require("@/components/common/tag/tag.styles");
let Tag = class Tag extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.tone = 'default';
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderIcon()}
      <slot></slot>
    `;
    }
    renderIcon() {
        if (!this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon part="icon" name=${this.icon}></mm-icon>
    `;
    }
};
Tag.styles = [tag_styles_1.tagStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], Tag.prototype, "tone", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Tag.prototype, "icon", void 0);
Tag = __decorate([
    (0, decorators_js_1.customElement)('mm-tag')
], Tag);
exports.Tag = Tag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGFnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUErQztBQUMvQyxxREFBMkQ7QUFJM0QseUNBQXNDO0FBQ3RDLG1FQUE0RTtBQUdyRSxJQUFNLEdBQUcsR0FBVCxNQUFNLEdBQUksU0FBUSxnQkFBVTtJQUE1Qjs7UUFFd0QsU0FBSSxHQUFZLFNBQVMsQ0FBQTtJQWlCeEYsQ0FBQztJQWRDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO1FBQ1AsSUFBSSxDQUFDLFVBQVUsRUFBRTs7S0FFcEIsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVO1FBQ2hCLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRTlCLE9BQU8sSUFBQSxVQUFJLEVBQUE7a0NBQ21CLElBQUksQ0FBQyxJQUFJO0tBQ3RDLENBQUE7SUFDSCxDQUFDOztBQWpCTSxVQUFNLEdBQUcsQ0FBQyxzQkFBUyxDQUFDLENBQUE7QUFDa0M7SUFBNUQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFVBQVUsRUFBRSxJQUFJLEVBQUUsQ0FBQztpQ0FBMEI7QUFDMUQ7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2lDQUFnQjtBQUhoQyxHQUFHO0lBRGYsSUFBQSw2QkFBYSxFQUFDLFFBQVEsQ0FBQztHQUNYLEdBQUcsQ0FtQmY7QUFuQlksa0JBQUcifQ==